// extracted by mini-css-extract-plugin
module.exports = {"error-page-container":"error-page_error-page-container__lAF4a","error-page-type":"error-page_error-page-type__2VNgv","error-page-message":"error-page_error-page-message__38uz9"};